import * as React from 'react';
import styles from './OtpTimer.css';
// Default value for otp timer
const OTP_TIMER_IN_SEC = 15;
class OtpTimer extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            minutes: 0,
            seconds: OTP_TIMER_IN_SEC
        };
    }
    componentDidMount() {
        this.initOtpTimer();
    }
    initOtpTimer(duration = OTP_TIMER_IN_SEC) {
        const { disableOtpTimer } = this.props;
        this.startOtpTimer = setInterval(() => {
            let minutes = 0;
            let seconds = 0;
            minutes = Math.floor(duration / 60);
            seconds = Math.floor(duration % 60);
            this.setState({
                minutes,
                seconds
            }, () => {
                // If timer is zero, disable otp timer and enable resend otp button again
                if (--duration < 0) {
                    if (typeof disableOtpTimer === 'function') {
                        disableOtpTimer();
                        clearInterval(this.startOtpTimer);
                    }
                }
            });
        }, 1000);
    }
    componentWillUnmount() {
        clearInterval(this.startOtpTimer);
    }
    render() {
        const { minutes, seconds } = this.state;
        let minutesText = minutes < 10 ? `0${minutes}` : `${minutes}`;
        let secondsText = seconds < 10 ? `0${seconds}` : `${seconds}`;
        let countDownTimer = `${minutesText}:${secondsText}`;
        return <div className={styles['countdown-timer']}>{countDownTimer}</div>;
    }
}
export default OtpTimer;
